export default __webpack_public_path__ + "bc3bd96c33c25bce8a2b7f3f65f5ecc2.png";